import { Action } from '@ngrx/store';

export class OneViewPermissionsAction implements Action {
  public static getOneViewPermissions = '[OneViewPermissions] get_one_view_permissions';
  public static getOneViewPermissionsSuccess = '[OneViewPermissions] get_one_view_permissions_success';
  public static getOneViewPermissionsError = '[OneViewPermissions] get_one_view_permissions_error';

  constructor(
    public type: string,
    public payload?: any,
  ) {}
}
